import Footer from '@/components/Footer';
import Header from '@/components/Header';
import User from '@/components/User/User';
import type { NextPage } from 'next';


const UserPage: NextPage = () => {

  return (
    <>
      <Header />
      <User />
      <Footer />
    </>
  )
}

export default UserPage
